import React from 'react';
import InfoModal from '../../../../../../components/data-display/InfoModal';
import Paragraph from '../../../../../../components/common/Paragraph';

const ModalRiskInvesrments = () => (
    <InfoModal
        buttonLabel=" Sobre Riesgo de las Inversiones"
        title="Riesgo de las Inversiones"
        width={780}
        buttonProps={{ style: { marginTop: '-10px' } }}
    >
        <Paragraph align="justify">
            Riesgo de Inversiones
        </Paragraph>
    </InfoModal>
);

export default ModalRiskInvesrments;
